<template>
  <div>
    <file-uploader :url="url"
      :name="name"
      :params="params"
      :ref="singleMediaRef"
      :transmit-ref="transmitRef"
      :transmitOptions="options"
      :class="source.url ? 'hidden-message' : ''"
      :max-file-size="5"
      :acceptedFileTypes="['image/png', 'image/jpeg']"
      @added-file="handleAddedFile(arguments[0])"
      @processing="handleProcessing"
      @success="handleSuccess"
      @error="handleError">
      <div
        :class="{
          'single-media-input d-flex align-items-center justify-content-center': true,
          'alert-danger': hasError(name)
        }"
        @click="triggerBrowse">
        <preloader :show="processing">
          <slot name="mask"></slot>
          <div class="media-preview" :style="'background-image: url(' + source.url + ')'">
          </div>
          <div class="media-blur-preview" :style="'background-image: url(' + source.url + ')'">
          </div>
        </preloader>
      </div>
    </file-uploader>
    <span class="text-muted mt-2 d-inline-block" v-if="width && height">
      <b>Tamanho da imagem: </b> {{ width }}x{{ height }}
    </span>
  </div>
</template>

<script>
  import { assign } from 'lodash'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        processing: false,
        transmitRef: '',
        singleMediaOptions: {
          clickable: false
        }
      }
    },

    props: {
      name: {
        type: String,
        default: 'media'
      },

      singleMediaRef: {
        type: String,
        default: 'SingleMediaRef'
      },

      url: {
        type: String,
        required: true
      },

      placeholder: {
        type: String,
        default: ''
      },

      collection: {
        type: String,
        default: 'default'
      },

      width: {
        type: Number,
        default: 0
      },

      height: {
        type: Number,
        default: 0
      },

      fields: {
        type: Object,
        default () { return {} }
      },

      source: {
        type: Object,
        default: () => {}
      },

      alt: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters({
        getError: 'errors/getError',
        hasError: 'errors/hasError'
      }),

      options () {
        return assign(this.singleMediaOptions, {
          autoProcessQueue: !this.width && !this.height,
          url: this.url
        })
      },

      params () {
        return assign(this.fields, {
          collection: this.collection
        })
      }
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      }),

      triggerBrowse () {
        if (this.processing === false) {
          this.$refs[this.singleMediaRef]
            .$refs[this.transmitRef]
            .triggerBrowseFiles()
        }
      },

      handleAddedFile (file) {
        const self = this
        if (self.width && self.height) {
          self.processing = true
          setTimeout(() => {
            const { width, height } = file
            if (self.width !== width || self.height !== height) {
              self.processing = false
              self.$toasted.error(`O arquivo enviado não possui o tamanho correto ${self.width}x${self.height}.`)
            } else {
              self.$refs[self.singleMediaRef].$refs[self.transmitRef].processFile(file)
            }
          }, 1000)
        }
      },

      handleSuccess () {
        this.$nextTick(() => {
          this.clearError([this.name])
          this.processing = false
        })
        this.$emit('success', arguments[0], arguments[1], arguments[2])
      },

      handleError (file, message, xhr) {
        this.$nextTick(() => { this.processing = false })
        this.$emit('error', file, message, xhr)
        if (message === "You can't upload files of this type.") {
          this.$refs[this.singleMediaRef].$refs[this.transmitRef].removeFile(file)
          this.$toasted.error('Você não pode fazer upload de arquivos desse tipo, por favor, tente novamente.')
        } else if (message.match('File is too big')) {
          this.$refs[this.singleMediaRef].$refs[this.transmitRef].removeFile(file)
          this.$toasted.error('O arquivo enviado é muito grande, por favor, tente outro arquivo.')
        } else if (message === 'You can not upload any more files.') {
          this.$refs[this.singleMediaRef].$refs[this.transmitRef].removeFile(file)
          this.$toasted.error('Você atingiu o limite de uploads!')
        } else if (xhr && xhr.status === 422) {
          this.$toasted.error('Ocorreu um erro ao realizar o upload do arquivo ' + file.name + '. Por favor, tente novamente.')
        } else {
          this.$toasted.error('Ocorreu um erro ao realizar o upload, por favor, tente novamente.')
        }
      },

      handleProcessing () {
        this.processing = true
        this.clearError([this.name])

        this.$emit('processing', arguments[0])
      }
    },

    created () {
      this.transmitRef = this.singleMediaRef + Math.random().toString(36).substr(2, 5)
    }
  }
</script>

<style lang="scss">
  .v-transmit__upload-area {
    overflow: hidden;
  }

  .media-blur-preview {
    position: absolute;
    width: 100% !important;
    height: 100%;
    z-index: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(80px);
    -webkit-transition: background-image 0.2s ease-in-out;
    transition: background-image 0.2s ease-in-out;
  }

  .hidden-message {
    .single-media-input {
      &:before {
        display: none;
      }
    }
  }

  .single-media-input {
    cursor: pointer;
    background-color: #e2e7ec;
    border: #e2e7ec 1px solid;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #000;
    position: relative;
    float: left;
    transition: background-color .2s linear;
    padding: 2px;
    width: 100%;
    height: 100%;
    min-height: 200px;

    &:before {
      content: 'Clique aqui para para fazer o upload da imagem';
      background: url('/static/img/defaults/upload.png') center/26px no-repeat transparent;
      width: 100%;
      text-align: center;
      font-size: 19px;
      font-weight: bold;
      line-height: 149px;
      height: 51px;
      position: absolute;
      color: #000;
      opacity: 0.4;
      z-index: 0;
      text-shadow: 0px 2px 1px #fff;
      left: 50%;
      top: 45%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }

    .media-preview {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 9;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      -webkit-transition: background-image 0.2s ease-in-out;
      transition: background-image 0.2s ease-in-out;
    }

    &.alert-danger {
      color: #813838;
      background-color: #fee2e1;
      border-color: #fdd6d6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/SingleMediaUploader.vue